import $ from '../$';
import ajax from '../functions/ajax';
$.ajax = ajax;
